<template>
  <div class="p-4">
    <div class="d-flex justify-end mb-3">
      <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="goToList"
            class="cursor-pointer"
          >
            <path
              d="M6 18.4998L17.9998 6.5"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.9998 18.4998L6 6.5"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
    </div>
    
      <div class="bg-demo">
          <div class="fs-12 fw-600 text-center txt-red p-1">DEMO VERSION</div>
      </div>
      <div class="row mt-14 mb-4">
              <div class="item-w cursor-pointer col-md-4 py-10 mr-5 px-6">
              <p class="txt-pri fs-18 fw-700">
                Kết nối hệ thống HIS
              </p>
              <p class="txt-pri fs-14 fw-500 mb-4">
                Sidebar has been collecting the best design links of the day since October 2012. It's maintained by Sacha Greif and built with Vulcan.js.
              </p>
              <div class="row">
                <div class="col-6">
                  <button class="btn fw-400 txt-pri btn--babyblue w-100 px-4 py-2">Tạm dừng</button>
                </div>
                <div class="col-6">
                  <button class="btn fw-400 c-btn bg-pri bd-pri text-white w-100 px-4 py-2">Kết nối</button>
                </div>
              </div>
            </div>

            <div class="item-w d-flex justify-content-center align-items-center cursor-pointer col-md-4" >
              <div>
                <svg
                class="ml-1"
                  width="80"
                  height="80"
                  viewBox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.1"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#20419B"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M41.6 38.3996H52.8C53.6836 38.3996 54.4 39.116 54.4 39.9996C54.4 40.8833 53.6836 41.5996 52.8 41.5996H41.6V52.7996C41.6 53.6833 40.8836 54.3996 40 54.3996C39.1163 54.3996 38.4 53.6833 38.4 52.7996V41.5996H27.2C26.3163 41.5996 25.6 40.8833 25.6 39.9996C25.6 39.116 26.3163 38.3996 27.2 38.3996H38.4V27.1996C38.4 26.316 39.1163 25.5996 40 25.5996C40.8836 25.5996 41.6 26.316 41.6 27.1996V38.3996Z"
                    fill="#20419B"
                  />
                </svg>

                <p class="mb-0 text-center mt-2 txt-black fw-500 fs-16">Thêm kết nối</p>
              </div>
            </div>
          </div>
      <!-- // -->
    <div class="bg-white rounded-2xl p-6 h-auto overflow-auto mt-2">
          <div>
            <p class="txt-pri d-flex items-center fs-20 fw-500"><svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.67334 15.4805C4.47556 15.4805 4.28222 15.5391 4.11777 15.649C3.95332 15.7589 3.82515 15.9151 3.74946 16.0978C3.67377 16.2805 3.65397 16.4816 3.69255 16.6756C3.73114 16.8695 3.82638 17.0477 3.96623 17.1876C4.10609 17.3274 4.28427 17.4227 4.47825 17.4613C4.67223 17.4998 4.8733 17.48 5.05602 17.4043C5.23875 17.3287 5.39493 17.2005 5.50481 17.036C5.61469 16.8716 5.67334 16.6783 5.67334 16.4805C5.67334 16.2153 5.56798 15.9609 5.38045 15.7734C5.19291 15.5858 4.93856 15.4805 4.67334 15.4805ZM8.67334 0.980469C4.67334 0.980469 0.67334 2.35047 0.67334 4.98047V16.9805C0.67334 19.6105 4.67334 20.9805 8.67334 20.9805C12.6733 20.9805 16.6733 19.6105 16.6733 16.9805V4.98047C16.6733 2.35047 12.6733 0.980469 8.67334 0.980469ZM14.6733 16.9805C14.6733 17.6905 12.3933 18.9805 8.67334 18.9805C4.95334 18.9805 2.67334 17.6905 2.67334 16.9805V13.7105C4.54541 14.6004 6.60123 15.0356 8.67334 14.9805C10.7454 15.0356 12.8013 14.6004 14.6733 13.7105V16.9805ZM14.6733 10.9805C14.6733 11.6905 12.3933 12.9805 8.67334 12.9805C4.95334 12.9805 2.67334 11.6905 2.67334 10.9805V7.71047C4.54541 8.60043 6.60123 9.03557 8.67334 8.98047C10.7454 9.03557 12.8013 8.60043 14.6733 7.71047V10.9805ZM8.67334 6.98047C4.95334 6.98047 2.67334 5.69047 2.67334 4.98047C2.67334 4.27047 4.95334 2.98047 8.67334 2.98047C12.3933 2.98047 14.6733 4.27047 14.6733 4.98047C14.6733 5.69047 12.3933 6.98047 8.67334 6.98047ZM4.67334 9.48047C4.47556 9.48047 4.28222 9.53912 4.11777 9.649C3.95332 9.75888 3.82515 9.91506 3.74946 10.0978C3.67377 10.2805 3.65397 10.4816 3.69255 10.6756C3.73114 10.8695 3.82638 11.0477 3.96623 11.1876C4.10609 11.3274 4.28427 11.4227 4.47825 11.4613C4.67223 11.4998 4.8733 11.48 5.05602 11.4043C5.23875 11.3287 5.39493 11.2005 5.50481 11.036C5.61469 10.8716 5.67334 10.6783 5.67334 10.4805C5.67334 10.2153 5.56798 9.9609 5.38045 9.77336C5.19291 9.58583 4.93856 9.48047 4.67334 9.48047Z" fill="#20419B"/>
            </svg>
            <span class="ml-2">Sources</span></p>
          </div>
          <div>
            <p class="fs-16 fw-400 text-black">Open API để thiết lập tích hợp hệ thống</p>
            <div class="border rounded-md border-grey-300 p-3">
              <input class="border-0 txt-grey-500 ml-2 focus:outline-none" type="text" value="https://developers.google.com">
            </div>
            
            <div class="mt-5">
              <p class="d-flex items-center">
                <svg class="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.6733 11.8005C18.4081 11.8005 18.1538 11.9058 17.9662 12.0934C17.7787 12.2809 17.6733 12.5353 17.6733 12.8005V19.9805C17.6733 20.2457 17.568 20.5 17.3804 20.6876C17.1929 20.8751 16.9386 20.9805 16.6733 20.9805H5.67334C5.40812 20.9805 5.15377 20.8751 4.96623 20.6876C4.7787 20.5 4.67334 20.2457 4.67334 19.9805V8.98047C4.67334 8.71525 4.7787 8.4609 4.96623 8.27336C5.15377 8.08583 5.40812 7.98047 5.67334 7.98047H12.8533C13.1186 7.98047 13.3729 7.87511 13.5604 7.68758C13.748 7.50004 13.8533 7.24569 13.8533 6.98047C13.8533 6.71525 13.748 6.4609 13.5604 6.27336C13.3729 6.08583 13.1186 5.98047 12.8533 5.98047H5.67334C4.87769 5.98047 4.11463 6.29654 3.55202 6.85915C2.98941 7.42176 2.67334 8.18482 2.67334 8.98047V19.9805C2.67334 20.7761 2.98941 21.5392 3.55202 22.1018C4.11463 22.6644 4.87769 22.9805 5.67334 22.9805H16.6733C17.469 22.9805 18.2321 22.6644 18.7947 22.1018C19.3573 21.5392 19.6733 20.7761 19.6733 19.9805V12.8005C19.6733 12.5353 19.568 12.2809 19.3804 12.0934C19.1929 11.9058 18.9386 11.8005 18.6733 11.8005ZM22.5933 3.60047C22.4919 3.35612 22.2977 3.16194 22.0533 3.06047C21.9331 3.00923 21.804 2.98205 21.6733 2.98047H15.6733C15.4081 2.98047 15.1538 3.08583 14.9662 3.27336C14.7787 3.4609 14.6733 3.71525 14.6733 3.98047C14.6733 4.24569 14.7787 4.50004 14.9662 4.68758C15.1538 4.87511 15.4081 4.98047 15.6733 4.98047H19.2633L8.96334 15.2705C8.86961 15.3634 8.79522 15.474 8.74445 15.5959C8.69368 15.7178 8.66754 15.8485 8.66754 15.9805C8.66754 16.1125 8.69368 16.2432 8.74445 16.365C8.79522 16.4869 8.86961 16.5975 8.96334 16.6905C9.0563 16.7842 9.1669 16.8586 9.28876 16.9094C9.41062 16.9601 9.54133 16.9863 9.67334 16.9863C9.80535 16.9863 9.93606 16.9601 10.0579 16.9094C10.1798 16.8586 10.2904 16.7842 10.3833 16.6905L20.6733 6.39047V9.98047C20.6733 10.2457 20.7787 10.5 20.9662 10.6876C21.1538 10.8751 21.4081 10.9805 21.6733 10.9805C21.9386 10.9805 22.1929 10.8751 22.3804 10.6876C22.568 10.5 22.6733 10.2457 22.6733 9.98047V3.98047C22.6718 3.84979 22.6446 3.72069 22.5933 3.60047V3.60047Z" fill="black"/>
                </svg>
              <span class="fs-16 fw-400 text-black">Hướng dẫn thiết lập cấu hình</span></p>
            </div>
          </div>

      </div>
    </div>
</template>

<script>
import { ButtonHoDo } from '@/components/Button'
import { IconSearch } from '@/components/Icon'
export default {
  components: { ButtonHoDo, IconSearch },
  name: 'SettingBenhAn',
  methods: {
    goToList () {
      this.$router.push({ path: '/ws-mgmt' })
    }
  }
}
</script>

<style scoped>
input {
    color: #000;
    font-size: 16px;
    font-weight: 500px;
}
.txt-red {
  color: #FF0E0E;
}
.bg-demo {
  background-color :#F6E6AD
}
.item-w {
  background-color: #ffffff;
  border: 1px solid #edeae9;
  cursor: pointer;
}
</style>